import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener("DOMContentLoaded", function() {

  // window.addEventListener("load", function() {

    (function ($) {

      const blocks = document.querySelectorAll(".block__hkbis-showreel-slider");

      blocks.forEach(block => {

        const logo_slider_container = block.querySelector('.block__hkbis-showreel-slider__logo-container');

        const post_id = block.dataset.postid;
        const block_id = block.dataset.blockid;

        if (block !== undefined) {

          const showreel = block.querySelector(".hkbis-showreel-slider-animation");
          if (showreel) {

            jQuery('html').css('scroll-behavior', 'auto');

            let lastSlider = 0;
            let endIndex = 0;

            const numberOfSlides = parseInt(showreel.dataset.numberofslides);
            const blockID = showreel.id;

            const navLinks = showreel.querySelectorAll('.block__hkbis-showreel-slider__nav-container__slider-container a');
            const mobileNavSlider = jQuery('#' + blockID.toString() + ' .block__hkbis-showreel-slider__nav-container__slider-container.slider');
            const contentSlider = jQuery('#' + blockID.toString() + ' .block__hkbis-showreel-slider__content-container.slider');

            let timeline = null;

            let logoSlider = null;
            let logoSlides = null;
            let logoHideElement = null;
            let nextButton = showreel.querySelector('.slick-next');
            let prevButton = showreel.querySelector('.slick-prev');
            let innerSliders = null;

            // const indicatorMobile = document.querySelector('#' + blockID.toString() + ' .slide-indicator-mobile--indicator');
            const indicatorDesktop = showreel.querySelector('.slide-indicator-desktop--indicator');

            const contentSlides = [...showreel.querySelectorAll('.block__hkbis-showreel-slider__content-container > .slick-list > .slick-track > .slick-slide')];
            const contentSliderSlickTrack = showreel.querySelector('.block__hkbis-showreel-slider__content-container > .slick-list > .slick-track');

            endIndex = [...navLinks].length - 1;

            const initSlicks = (element) => {
              let slickElement = $(element);
              slickElement.slick();
              slickElement.find('.slider').slick();

              // ---- prevent click when dragging on modals inside slick with custom attr ----
              const clickElements = slickElement.find('button[data-bs-target-custom]');
              clickElements.each(function() {
                $(this).removeAttr('data-bs-toggle')
              });

              const delta = 2;
              let startX;
              let startY;

              clickElements.on('mousedown', function (event) {
                startX = event.pageX;
                startY = event.pageY;
              });

              clickElements.on('mouseup', function (event) {
                const diffX = Math.abs(event.pageX - startX);
                const diffY = Math.abs(event.pageY - startY);
                const $this = $(this);

                if (diffX < delta && diffY < delta) {
                  const target = $($this.attr('data-bs-target-custom'));
                  if ($this.attr('data-bs-target-custom-index')) {
                    const index = parseInt($this.attr('data-bs-target-custom-index'));
                    target.find('.slider').slick('slickGoTo', index);
                  }
                  target.modal('show');
                }
              });

              clickElements.mousedown(function(e){
                  $(document).mousemove(function(){})
              }).mouseup(function(){
                  $(document).unbind('mousemove')
              })
              // ---- prevent click when dragging on modals inside slick with custom attr end ----
            }

            const resizeVerticalSlider = () => {
              let minHeight = 0;
              contentSliderSlickTrack.style.minHeight = 'unset';
              contentSlides.forEach(slide => {
                slide.style.minHeight = 'unset';
                const currentHeight = slide.getBoundingClientRect().height;
                if (currentHeight >= minHeight) {
                  minHeight = currentHeight;
                }
              });
              contentSlides.forEach(slide => {
                slide.style.minHeight = minHeight.toString() + 'px';
              });
              contentSliderSlickTrack.style.minHeight = (minHeight * 3).toString() + 'px';
            }

            const setActiveMenu = (index) => {
              [...navLinks].forEach(link => {
                link.classList.remove(['active']);
              })
              navLinks[index].
              classList.add(['active']);
            }

            const moveIndicators = (index, lastSlider, numberOfSlides) => {
              // gsap.to(indicatorMobile,  {left: (1 / numberOfSlides * 100 * index).toString() + '%'});
              if (lastSlider > index) {
                gsap.to(indicatorDesktop, {top: navLinks[index].parentNode.offsetTop +8});
              } else if (lastSlider < index) {
                gsap.to(indicatorDesktop, {top: navLinks[index].parentNode.offsetTop -10});
              }
            }

            const hideLogosOnEmptyElement = (index) => {
              if (logoSlides?.[index]?.classList?.contains('no-content')) {
                gsap.to(logoHideElement, {top: 0});
              } else {
                gsap.to(logoHideElement, {top: '-100%'});
              }
            }

            const animateArrows = (index) => {
              const allArrows = showreel.querySelectorAll('.block__hkbis-showreel-slider__logo-container__slide .next, .block__hkbis-showreel-slider__logo-container__slide .prev');
              const arrows = logoSlides?.[index]?.querySelectorAll('.next, .prev');

              if (allArrows) {
                [...allArrows].forEach(e => {
                  e.classList.remove('active');
                });
              }
              if (arrows) {
                [...arrows].forEach(e => {
                  e.classList.add('active');
                });
              }
            }

            const moveSliders = (index) => {

              if (index < 0) {
                index = endIndex;
              }
              if (index > endIndex) {
                index = 0;
              }

              setActiveMenu(index);
              moveIndicators(index, lastSlider, numberOfSlides);
              hideLogosOnEmptyElement(index);
              animateArrows(index);
              if(document.readyState === "complete") {
                if(window.innerWidth < 992 && mobileNavSlider){
                  mobileNavSlider.slick('slickGoTo', index);
                }
                contentSlider.slick('slickGoTo', index);
                if (logoSlider) {
                  logoSlider.slick('slickCurrentSlide');
                  logoSlider.slick('slickGoTo', index);
                }
              }
              lastSlider = index;
            }

            const initsAfterAjaxLogos = (timeline) => {

              innerSliders = jQuery('#' + blockID.toString() + ' .inner-slider.slider');
              logoSlider = jQuery('#' + blockID.toString() + ' .block__hkbis-showreel-slider__logo-container');
              logoSlides = showreel.querySelectorAll('.block__hkbis-showreel-slider__logo-container__slide');
              logoHideElement = showreel.querySelector('.block__hkbis-showreel-slider__logo-hide-element');

              logoSlider.on('init', function() {
                animateArrows(0);
                timeline?.scrollTrigger.refresh();
              });

              initSlicks(logo_slider_container);
              hideLogosOnEmptyElement(0);

              innerSliders.each(function() {
                jQuery(this).on('mousedown touchstart', function(){
                  contentSlider.slick('setOption', {
                    swipe: false
                  });
                });
              });

              timeline?.scrollTrigger.refresh();
              resizeVerticalSlider();
            }

            const initsAfterAjaxReviews = (timeline) => {

              innerSliders = jQuery('#' + blockID.toString() + ' .inner-slider.slider');

              innerSliders.each(function() {
                jQuery(this).on('mousedown touchstart', function(){
                  contentSlider.slick('setOption', {
                    swipe: false
                  });
                });
              });
              timeline?.scrollTrigger.refresh();
              resizeVerticalSlider();
            }

            // --------------------------------------------------------
            // --------------------------------------------------------

            resizeVerticalSlider();
            window.addEventListener('resize', function() {
              resizeVerticalSlider();
            });

            navLinks[0].classList.add(['active']);
            gsap.to(indicatorDesktop, {top: navLinks[0].parentNode.offsetTop +8});

            [...navLinks].forEach(link => {
              link.addEventListener('click', function() {
                const index = link.dataset.index;
                moveSliders(index);
              });
            });

            if (mobileNavSlider) {
              mobileNavSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                moveSliders(nextSlide);
              });
            }

            // contentSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            //   if(window.innerWidth < 992){
            //     moveSliders(nextSlide);
            //   }
            // });

            nextButton.addEventListener('click', function(e){
              moveSliders(lastSlider + 1);
            });

            prevButton.addEventListener('click', function(e){
              moveSliders(lastSlider - 1);
            });

            ScrollTrigger.matchMedia({
              "(min-width: 992px)": function () {

                timeline = gsap.timeline({
                  scrollTrigger: {
                    trigger: showreel,
                    pin: showreel,
                    pinSpacing: false,
                    anticipatePin: 1,
                    scrub: 1,
                    start: "center center",
                    end: "+=2000",
                    ease: "none",
                    toggleClass: 'pinned',
                    preventOverlaps: true,
                    fastScrollEnd: true,
                  },
                  ease: "none",
                });

                timeline.duration(1000);

                for (let i = 0; i < numberOfSlides; i++) {
                  timeline.add( ["slide-" + i.toString(), gsap.delayedCall(100, moveSliders, [i])]);
                }
                timeline.add( ["end", gsap.delayedCall(100, undefined, null)] );

                const resizeObserver = new ResizeObserver(function() {
                  if (timeline?.scrollTrigger) {
                    timeline.scrollTrigger.refresh()
                  }
                });
                resizeObserver.observe(document.body)
              }
            });

            let ajaxTrigger = gsap.timeline({
              scrollTrigger: {
                trigger: showreel,
                start: 'top-=1000 bottom',
                onEnter: () => {
                  console.log('load showreel inner sliders');
                  $.ajax({
                    type: 'post',
                    url: ajaxurl,
                    data: {action: 'hkbis_ajax_block_call', data: {type: 'logos', post_id, block_id}},
                    success: (response) => {
                      logo_slider_container.innerHTML = response;
                      initsAfterAjaxLogos(timeline);
                    },
                    error: function (error) {
                        console.log("Error:", error);
                    }
                  });

                  $.ajax({
                    type: 'post',
                    url: ajaxurl,
                    data: {action: 'hkbis_ajax_block_call', data: {type: 'reviews', post_id, block_id}},
                    success: function (response) {
                      const parser = new DOMParser();
                      const html = parser.parseFromString(response, 'text/html');

                      const reviewSliders = [...html.querySelectorAll('.ajax-slider-container')];
                      reviewSliders.forEach(slider => {
                        const parentElementSelector = slider.dataset.parent;
                        if (parentElementSelector) {
                          const parent = showreel.querySelector(parentElementSelector);
                          if (parent) {
                            parent.innerHTML = slider.innerHTML;
                            initSlicks(parent);
                          }
                        }
                      })
                      initsAfterAjaxReviews(timeline);
                    },
                    error: function (error) {
                        console.log("Error:", error);
                    }
                  });
                },
                once: true,
              },
            });
          }
        }
      });
    })(jQuery);
  // });
});



